/**
 * Product pricing helpers — mirrors future DB fields:
 * - price: current selling price (what the customer pays)
 * - originalPrice: optional list price before discount
 * - discountPercent: optional stored discount (computed when missing)
 */
export function getProductPricing(product) {
    const { precio, precioOriginal, porcentajeDescuento, abreviatura = "USD" } = product;

    if (precioOriginal != null && precioOriginal > precio) {
        const computedPercent = Math.round((1 - precio / precioOriginal) * 100);
        return {
            abreviatura,
            salePrice: precio,
            precioOriginal,
            porcentajeDescuento: porcentajeDescuento ?? computedPercent,
            isOnSale: true,
        };
    }

    if (porcentajeDescuento != null && porcentajeDescuento > 0) {
        const computedOriginal = precio / (1 - porcentajeDescuento / 100);
        return {
            abreviatura,
            salePrice: precio,
            precioOriginal: Math.round(computedOriginal * 100) / 100,
            porcentajeDescuento,
            isOnSale: true,
        };
    }

    return {
        abreviatura,
        salePrice: precio,
        originalPrice: null,
        discountPercent: null,
        isOnSale: false,
    };
}

export function formatProductPrice(amount, abreviatura, locale) {
    return new Intl.NumberFormat(locale, { style: "currency", currency: abreviatura }).format(amount);
}

export function getPriceLocale(language) {
    if (language === "es") return "es-ES";
    if (language === "pt") return "pt-BR";
    return "en-US";
}
